// import libraries
import { create } from 'zustand';

// import slices
import { createCommonSlices } from './common';
import { createFeatureSlices } from './features';

// Root store factory
export const useAppStore = create((set, get) => ({
  // attach common slices (shared across features)
  common: {
    ...createCommonSlices(set, get),
  },
  // attach feature-specific slices
  features: {
    ...createFeatureSlices(set, get),
  },
}));

// Helper selector creators
export const selectCommon = (state) => state.common;
export const selectFeatures = (state) => state.features;
